import React from 'react';
import SingleColumnTemplate from '@templates/SingleColumn';
import List from '@components/List';
import RawHTML from '@components/RawHTML';

export default function KeynotesAndLectures({
  lists: _lists,
  intro: _intro,
  data,
  ...restProps
}) {
  const intro = _intro ?? <RawHTML>{data?.markdownRemark?.html}</RawHTML>;
  const lists = _lists ?? data?.markdownRemark?.frontmatter?.lists ?? [];

  return (
    <SingleColumnTemplate {...restProps}>
      {intro}
      {lists.map((list, index) => (
        <List
          key={index}
          {...list}
        />
      ))}
    </SingleColumnTemplate>
  );
}
